import { Nav, NavItem, NavLink } from "reactstrap";
import { Badges } from "../../../../AbstractElements";
import { Inbox } from "../../../../Constants/Constants";
import { LetterBoxSidebar } from "../../../../Data/Applications/LetterBox/LetterBox";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { LetterBoxNavType } from "../../../../Types/LatterBoxType";
import SvgIcon from "../../../CommonComponents/SvgIcon/SvgIcon";
import AddLabel from "./AddLabel";

const EmailNavMenu:React.FC<LetterBoxNavType> = ({ navId, setNavId }) => {
  const { inboxEmail } = useAppSelector((state) => state.letterBox);
  let starBadges = inboxEmail.filter((data) => data.star === true && 1);

  return (
    <Nav pills tabs className="main-menu email-category border-0">
      {LetterBoxSidebar.map((data, i) => (
        <NavItem key={i}>
          <NavLink className={`border-0 ${navId === data.id ? "active" : ""}`} onClick={() => setNavId(data.id)}>
            <SvgIcon className={`stroke-icon ${data.color ? `stroke-${data.color}` : ""}`} iconId={data.icon} />
            <div>
              {data.title}
              {data.badge && <Badges color="light-primary">{data.title === Inbox ? inboxEmail.length : starBadges.length}</Badges>}
            </div>
          </NavLink>
        </NavItem>
      ))}
      <AddLabel />
    </Nav>
  );
};

export default EmailNavMenu;
